import React from 'react';
import { Chip } from '@mui/material';
import { statusStyle } from '../../theme/orderStatus';

export interface StatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

export const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'small' }) => {
  const style = statusStyle(status);
  return (
    <Chip
      label={style.label}
      size={size}
      sx={{ bgcolor: style.bg, color: style.fg, fontSize: 12, fontWeight: 600 }}
    />
  );
};
